module.exports = __webpack_public_path__ + "static/img/BB.9f13b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/BB.png
// module id = XmYi
// module chunks = 0